import { useLocation } from 'react-router-dom'

/**
 * VRG-712 — a link that opens a list on ONE record (Analytics → Website → Lead journeys → Access
 * or Sales → People) puts the record's search text in the router STATE, never the URL: the text is
 * an email, and a URL is kept in history, logs and analytics. The list passes it to its Table's
 * `search`, which seeds the search box and the grid's quick filter; the reader can clear it like
 * any search. It sits beside `useReferrerState`'s `backTo`/`backLabel` in the same state object.
 */
export interface LinkedSearchState {
  search?: string
}

export const linkedSearchState = (
  search: string,
  referrer?: { backTo: string; backLabel: string },
): LinkedSearchState & Partial<{ backTo: string; backLabel: string }> => ({ ...(referrer ?? {}), search })

export const useLinkedSearch = (): string | undefined => {
  const { state } = useLocation()
  const search = (state as LinkedSearchState | null)?.search
  return typeof search === 'string' && search.trim() ? search : undefined
}
